import { useEffect, useMemo } from 'react';
import { useSiteContext } from '../../SiteContext';
/**
 * Traverse all components to get a flattened array of route components
 */
export function useSiteRouteComponents() {
    const { siteComponents, setSiteComponents, subscribe, unsubscribe } = useSiteContext();
    // Subscribe to any component changes coming from the component editor
    useEffect(() => {
        const handleSubscribe = (component) => {
            setSiteComponents(components => [...components]);
        };
        subscribe('route', handleSubscribe);
        return () => unsubscribe('route', handleSubscribe);
    }, [setSiteComponents, subscribe, unsubscribe]);
    return useMemo(() => {
        const results = [];
        const filterComponents = (components) => {
            for (const component of components) {
                if (component.type === 'route') {
                    results.push(component);
                }
                if (component.children) {
                    filterComponents(component.children);
                }
            }
            return results;
        };
        return filterComponents(siteComponents).sort((a, b) => {
            var _a, _b, _c, _d;
            const pathA = ((_b = (_a = a.props) === null || _a === void 0 ? void 0 : _a.path) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '';
            const pathB = ((_d = (_c = b.props) === null || _c === void 0 ? void 0 : _c.path) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || '';
            return pathA < pathB ? -1 : pathA > pathB ? 1 : 0;
        });
    }, [siteComponents]);
}
//# sourceMappingURL=useSiteRouteComponents.js.map